module.exports = __webpack_public_path__ + "img/pexels-photo-3254131.9715dce3.jpeg";